import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=57c28004&scoped=true"
import script from "./FooterNavigation.vue?vue&type=script&lang=ts"
export * from "./FooterNavigation.vue?vue&type=script&lang=ts"
import style0 from "./FooterNavigation.vue?vue&type=style&index=0&id=57c28004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c28004",
  null
  
)

export default component.exports